module.exports = __webpack_public_path__ + "static/media/2_12.5db5456a.png";